import React from "react";

const LandingPage: React.FC = () => {
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        position: "absolute",
      }}
    >
      <iframe
        src={"https://info.senf.app"}
        height="100%"
        width="100%"
        title="Inf0"
        frameBorder="0"
      ></iframe>
    </div>
  );
};

export default LandingPage;
